import { Button, FormElement, RadioBox } from "@/components";
import { Box, Flex, Input, Select, Text } from "@chakra-ui/react";
import { PAID_MODE_GROUP, usePaymentRoomState } from "@shared/client";
import { useEffect, useRef } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { CustomInputTitle, CustomTitle } from "./payerInfo.style";
import { PayerInfoProps } from "./payerInfo.type";
import { useGetCoupon } from "@/shared/server";
import { useModal } from "@/contexts";
import { CouponModal } from "@/domains/components";

export const PayerInfo = ({ control, account, use, onlyUseAccount }: PayerInfoProps) => {
    const { setValue } = useFormContext();
    const payMethod = useWatch({ control, name: "payMethod" });
    const { setModalContent, openModal, setIconName } = useModal();
    // const toast = useToast();
    // const [couponApply, setCouponApply] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);
    // const { mutate } = usePostCouponCheck();
    const [paymentRoom, setPaymentRoom] = usePaymentRoomState();
    const edate = paymentRoom[0]?.date
        .split("~")[1]
        .trim()
        .replace(/\(.*?\)/, "");
    const sdate = paymentRoom[0]?.date
        .split("~")[0]
        .trim()
        .replace(/\(.*?\)/, "");
    const { data: couponData } = useGetCoupon({ sdate, edate });
    const updatedPaymentModes =
        onlyUseAccount === "true"
            ? PAID_MODE_GROUP.filter((mode) => mode.name === "account")
            : use === "true"
              ? PAID_MODE_GROUP
              : PAID_MODE_GROUP.filter((mode) => mode.name !== "account");
    const couponTotalPrice = paymentRoom.reduce((sum, room) => sum + room.couponDiscount, 0);
    // const handleCouponCancel = () => {
    //     setCouponApply(false);
    //     setPaymentRoom((prev) =>
    //         prev.map((item) => ({
    //             ...item,
    //             couponDiscount: 0,
    //             couponName: null,
    //             coupon_idx: null,
    //         })),
    //     );
    //     toast({
    //         duration: 3000,
    //         position: "top",
    //         title: "쿠폰 적용 취소",
    //         status: "warning",
    //     });
    // };
    useEffect(() => {
        if (payMethod !== "account") setValue("bank", "");
    }, [payMethod]);

    return (
        <Flex flex="1" flexDir="column" rowGap="24px" borderRadius="16px" boxSizing="border-box">
            <>
                <CustomTitle>예약정보입력</CustomTitle>
                <Flex flexDir="column">
                    <CustomInputTitle>예약자정보</CustomInputTitle>
                    <Box>
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="text"
                            placeholder="예약자 성함"
                            name="buyer"
                            id="buyer"
                            label="예약자명"
                            value=""
                            isRequired={true}
                        />
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="tel"
                            placeholder="ex)010-0000-0000"
                            name="phoneNumber"
                            id="phoneNumber"
                            label="연락처"
                            value=""
                            isRequired={true}
                        />
                        <FormElement
                            widthSize="full"
                            control={control}
                            type="text"
                            placeholder="예약 시 요청사항"
                            name="memo"
                            id="memo"
                            label="예약시 요청사항"
                            value=""
                            isRequired={false}
                        />
                    </Box>
                </Flex>
                {couponData && couponData.list.length > 0 && (
                    <Flex flexDir="column" gap="8px">
                        <Text>쿠폰</Text>
                        <Box>
                            <Flex gap="8px" alignItems="center">
                                <Input
                                    textAlign="right"
                                    type="text"
                                    width="320px"
                                    ref={inputRef}
                                    name="input_coupon"
                                    id="input_coupon"
                                    defaultValue=""
                                    color={couponTotalPrice > 0 ? "black" : "gray.500"}
                                    value={couponTotalPrice > 0 ? couponTotalPrice.toLocaleString() : ""}
                                    disabled={true}
                                />
                                <Button
                                    type="button"
                                    w="120px"
                                    onClick={() => {
                                        if (couponTotalPrice === 0) {
                                            setModalContent(<CouponModal list={couponData.list} />);
                                            setIconName("close");
                                            openModal();
                                            return;
                                        }
                                        if (confirm("쿠폰 적용을 취소하시겠습니까?")) {
                                            setPaymentRoom((prev) =>
                                                prev.map((item) => ({
                                                    ...item,
                                                    couponDiscount: 0,
                                                    couponName: null,
                                                    coupon_idx: null,
                                                })),
                                            );
                                        }
                                    }}
                                >
                                    {couponTotalPrice > 0 ? "쿠폰 취소" : "조회"}
                                </Button>
                                {/* {couponApply && (
                            <Button disabled={!couponApply} type="button" w="120px" onClick={handleCouponCancel}>
                                취소
                            </Button>
                        )} */}
                            </Flex>
                            {couponTotalPrice === 0 && (
                                <Text fontSize="12px" color="#dd107f">
                                    사용 가능한 쿠폰{couponData.list.length}장
                                </Text>
                            )}
                            <Text fontSize="12px" color="#dd107f">
                                ※ 쿠폰은 추가 금액을 제외한 객실 금액에서만 적용이 됩니다.
                            </Text>
                        </Box>
                    </Flex>
                )}

                <Flex flexDir="column" gap="8px">
                    <CustomInputTitle>결제수단</CustomInputTitle>
                    <RadioBox control={control} name="payMethod" option={updatedPaymentModes} />
                </Flex>
                {use === "true" && payMethod === "account" && (
                    <Flex flexDir="column" gap="8px">
                        <CustomInputTitle>입금 계좌선택</CustomInputTitle>
                        <Controller
                            control={control}
                            name="bank"
                            defaultValue=""
                            render={({ field }) => (
                                <Select {...field} placeholder="입금계좌선택">
                                    {account.map((it: { [key: string]: any }, index: number) => (
                                        <option value={it.bank} key={index}>
                                            {it.bank}
                                        </option>
                                    ))}
                                </Select>
                            )}
                        />
                    </Flex>
                )}
            </>
        </Flex>
    );
};
